import { Colors } from '@treneo/shared/themes';

import { styled } from '../styled';

import { Box } from './box';

type VerticalLineProps = Readonly<{
  width?: number;
  color?: string;
  margin?: string;
  flex?: string;
  alignSelf?: string;
}>;

const StyledLine = styled(Box)<{
  width: number;
  color: string;
  margin: string;
  flex: string;
  alignSelf: string;
}>`
  width: ${({ width }) => width}px;
  background: ${({ color }) => color};
  margin: ${({ margin }) => margin};
  flex: ${({ flex }) => flex};
  align-self: ${({ alignSelf }) => alignSelf};
`;

export const VerticalLine = ({
  width = 1,
  color = Colors.lineGrey,
  margin = '0',
  flex = 'none',
  alignSelf = 'stretch'
}: VerticalLineProps) => (
  <StyledLine width={width} color={color} margin={margin} flex={flex} alignSelf={alignSelf} />
);
